﻿import config from "../config"
const baseUrl = config.base_url + "sdd_tag/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    remove: {
        url:  baseUrl + "delete",
        type: "get",
    },
    update: {
        url:  baseUrl + "update",
        type: "post",
    },
    insert: {
        url:  baseUrl + "insert",
        type: "post",
    },

}

